module.exports = __webpack_public_path__ + "static/InteriorCustom5Desktop-b0393883811a84baa62d82fda2c8e923.jpg";